import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReference: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconReference"><Path fillRule="evenodd" clipRule="evenodd" d="M18 2C19.1046 2 20 2.89543 20 4V21.5C20 21.7761 19.7761 22 19.5 22H6C4.89543 22 4 21.1046 4 20V4.5C4 3.11929 5.11929 2 6.5 2H18ZM6 19C5.44772 19 5 19.4477 5 20C5 20.5523 5.44772 21 6 21H19V19H6ZM6 16C5.44772 16 5 16.4477 5 17C5 17.5523 5.44772 18 6 18H19V16H6ZM8.5 6C8.22386 6 8 6.22386 8 6.5C8 6.77614 8.22386 7 8.5 7H15.5C15.7761 7 16 6.77614 16 6.5C16 6.22386 15.7761 6 15.5 6H8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReference;
